import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ActionNotification from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/FileBlocking/ActionNotification';
import ApproveBlockList from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/FileBlocking/ApproveBlockList';
import Rules from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/FileBlocking/Rules';

const FileBlocking = () => {
  const { t } = useTranslation();
  return (
    <Box>
      <Tabs>
        <TabList>
          <Tab>{t('policy.rules')}</Tab>
          <Tab>{t('policy.approvedAndBlockedList')}</Tab>
          <Tab>{t('policy.actionAndNotification')}</Tab>
        </TabList>
        <TabPanels py="2x">
          <TabPanel>
            <Rules applyBoundShow={false} blockAdditionalFileShow={false} />
          </TabPanel>
          <TabPanel>
            <ApproveBlockList />
          </TabPanel>
          <TabPanel>
            <ActionNotification advancedOptionShow={true} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
export default React.memo(FileBlocking);
